"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Provider: function() {
        return Provider;
    },
    useFluent: function() {
        return useFluent;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
/**
 * @internal
 */ const ProviderContext = /*#__PURE__*/ _react.createContext(undefined);
const providerContextDefaultValue = {
    // eslint-disable-next-line no-restricted-globals
    targetDocument: typeof document === 'object' ? document : undefined,
    dir: 'ltr'
};
const Provider = ProviderContext.Provider;
function useFluent() {
    var _React_useContext;
    return (_React_useContext = _react.useContext(ProviderContext)) !== null && _React_useContext !== void 0 ? _React_useContext : providerContextDefaultValue;
}
